export default "__VITE_ASSET__773b8bc0__"